import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Tabs, ScrollArea, Divider, Table, NumberInput, Text, NumberFormatter, Select } from '@mantine/core'
import LoadingData from '../../ui/LoadingData'
import { getDetailRequestQuotePrice } from '../../../services/request-quote'
import { getGlobalSettings } from '../../../services/global-settings'
import { IconCheck, IconPlus, IconTrash } from '@tabler/icons-react'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { validation } from '../../../plugins/validation'
import { addRequestQuoteBulkPrice, deleteRequestQuoteBulkPrice, updateRequestQuoteBulkPrice } from '../../../services/request-quote'

const priceValidation = {
  shipping_type: { 
    isError: false, 
    message: '' 
  },
}

const labelTable = [
  {
    label: 'Spesification / Variant',
    width: 10
  },
  {
    label: 'Qty',
    width: 5
  },
  {
    label: 'Supplier Price/unit',
    width: 10
  },
  {
    label: 'Landed Cost/unit',
    width: 40
  },
  {
    label: 'VAT Charge',
    width: 40
  },
]

const defaultShipmentMethodList = [
  {
    value: 'AIR_CARGO',
    name: 'air',
    label: 'Shipping via Air Cargo',
    disabled: false,
    message: '',
  },
  {
    value: 'OCEAN_CARGO',
    name: 'ocean',
    label: 'Shipping via Ocean Cargo',
    disabled: false,
    message: '',
  },
  {
    value: 'TRUCKING',
    name: 'official_trucking',
    label: 'Shipping via Trucking',
    disabled: false,
    message: '',
  },
  {
    value: 'AIR_COURIER',
    name: 'air_courier',
    label: 'Shipping via Air Courier',
    disabled: false,
    message: '',
  },
  {
    value: 'AIR_CARGO_DTD',
    name: 'air_dtd',
    label: 'Shipping via Air Door-to-Door',
    disabled: false,
    message: '',
  },
  {
    value: 'OCEAN_CARGO_DTD',
    name: 'ocean_dtd',
    label: 'Shipping via Ocean Door-to-Door',
    disabled: false,
    message: '',
  },
  {
    value: 'TRUCKING_UNOFFICIAL',
    name: 'unofficial_trucking',
    label: 'Shipping via Trucking Unofficial',
    disabled: false,
    message: '',
  },
]

const FormQuoteSetPrices = ({ dataProductQuote, onCloseModal, reloadList }) => {
  const [quotePrices, setQuotePrices] = useState([])
  const [validationPrice, setValidationPrice] = useState(priceValidation)
  const [availableShipmentMethods, setAvailableShipmentMethods] = useState(defaultShipmentMethodList)
  const [loadingData, setLoadingData] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [selectedIndexPrice, setSelectedIndexPrice] = useState(`0`)
  const [deletePrices, setDeletePrices] = useState([])

  const submitQuotePrices = async () => {
    setLoadingForm(true)
    setValidationPrice(priceValidation)
    let validatePrice = {}
    for (let i = 0 ; i < quotePrices.length ; i++) {
      validatePrice = {
        shipping_type: quotePrices[i].shipping_type,
      }
    }
    const isErrorPrice = validation(validatePrice, setValidationPrice)
    if (isErrorPrice) {
      notificationError('Submit Landed Cost Product Quote Error', 'Check recheck your form')
      setLoadingForm(false)
      return
    }
    try {
      let createBulkPrice = null
      let updateBulkPrice = null
      const findDataCreateBulk = quotePrices.filter(val => val.isUnSavedPrice === true)
      const findDataRecentBulk = quotePrices.filter(val => val.isUnSavedPrice === false)
      if (findDataCreateBulk.length > 0) {
        const remapCreateBulk = findDataCreateBulk.map((val) => {
          const variants = val.variants
          return variants.map((detail) => {
            return {
              specification: detail.specification,
              landed_cost: detail.landed_cost,
              landed_cost_currency: detail.landed_cost_currency,
              product_variation_id: detail.product_variation_id,
              qty: detail.qty,
              shipping_type: val.shipping_type,
              supplier_price: detail.supplier_price,
              supplier_currency: detail.supplier_currency,
              vat: detail.vat
            }
          })
        })
        const payload = {
          prices: remapCreateBulk.flatMap((val) => val)
        }
        createBulkPrice = await handleCreateBulkPrice(dataProductQuote.id, payload)
      }
      if (findDataRecentBulk.length > 0) {
        const remapRecentBulk = findDataRecentBulk.map((val) => {
          const variants = val.variants
          return variants.map((detail) => {
            return {
              id: detail.id,
              shipping_type: val.shipping_type,
              landed_cost: detail.landed_cost,
              vat: detail.vat
            }
          })
        })
        const payload = {
          prices: remapRecentBulk.flatMap((val) => val)
        }
        updateBulkPrice = await handleUpdateBulkPrice(dataProductQuote.id, payload)
      }
      if (deletePrices.length > 0) {
        await handleDeleteBulkPrice(deletePrices)
      }
      if (createBulkPrice !== null ? createBulkPrice.success : '' || updateBulkPrice !== null ? updateBulkPrice.success : '') {
        onCloseModalForm()
        reloadList()
        notificationSuccess('Update Price Product Quote Successfully', 'You have been updated price product quote')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Price Product Quote Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
    
    
  }

  const handleCreateBulkPrice = async (id, payload) => {
    try {
      const response = await addRequestQuoteBulkPrice(id, payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateBulkPrice = async (id, payload) => {
    try {
      const response = await updateRequestQuoteBulkPrice(id, payload)
      return response
    } catch (error) {
      console.log(error)    
    }
  }

  const handleDeleteBulkPrice = async (dataDeletePriceQuote) => {
    const payload = { ids: dataDeletePriceQuote }
    try {
      const response = await deleteRequestQuoteBulkPrice(dataProductQuote.id, payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetShipmentMethodsList = async (originId, destinationId) => {
    const params = {
      'filter[key][in]': 'available_shipment_methods',
      'page[limit]': 100,
      'filter[country_id][in]': destinationId,
      'filter[source_country_id][in]': originId,
    }
    try {
      const response = await getGlobalSettings(params)
      const { data } = response
      const remap = data.map((val) => {
        return val.attributes.value
      })
      return remap

    } catch (error) {
      console.log(error)
    }
  }

  const getPrices = async (quote) => {
    setLoadingData(true)
      const params = {
        'include': 'product_variation',
        'page[limit]': 1000,
      }
      try {
        const response = await getDetailRequestQuotePrice(quote.id, params)
        if (response.success) {

          const remapData = (response) => {
            const { data, included } = response
            const { product_variation } = included

            const remapDataPrice = data.map((val) => {
              const { attributes } = val
              const hasVariant = attributes.product_variation_id

              const generateSpesification = () => {
                return hasVariant
                  ? product_variation[attributes.product_variation_id].attributes.options_values
                  : `${attributes.specification.name} - ${attributes.specification.option}`
              }
              
              return {
                ...attributes,
                variantSpesification: generateSpesification()
              }
            })

            return remapDataPrice
          }

          const logicGrouping = (_rawData) => {
            const _group = Map.groupBy(_rawData, (e) => e.shipping_type.name)
            const obj = Object.fromEntries(_group)
            const arrayOfObjects = Object.entries(obj).map(([key, value]) => {
              return {
                shipping_type: key,
                isUnSavedPrice: false,
                variants: value
              }
            })
        
            return arrayOfObjects
          }

          const rawData = remapData(response)
          const finalData = logicGrouping(rawData)
          setQuotePrices(finalData)

          const getAvailableShipment = await handleGetShipmentMethodsList(quote.origin_country_id, quote.destination_country_id)
          if (getAvailableShipment) {
            const selectedShipment = (shipmentMethodName) => {
              const data = finalData
              const selected = data.find((val) => val.shipping_type === shipmentMethodName)
              return Boolean(selected)
            }

            const setMessageShipment = (availableShipment, selectedShipment) => {
              if (!availableShipment ) {
                return 'Not Available'
              } else if (selectedShipment) {
                return 'Selected'
              } else if (!selectedShipment) {
                return ''
              }
            }

            const remapAvailableShipment = availableShipmentMethods.map((val) => {
              const isSelected = selectedShipment(val.value)
              const remap = {
                ...val,
                disabled: !getAvailableShipment.includes(val.name),
                message: setMessageShipment(getAvailableShipment.includes(val.name), isSelected)
              }
              return remap
            })
            setAvailableShipmentMethods(remapAvailableShipment)
          }
        }
      } catch (error) {
        console.log(error)
      }
      finally {
        setLoadingData(false)
      }
  }

  const handleUpdateShipmentMethods = (dataQuote) => {

    const selectedShipment = (shipmentMethodName) => {
      const data = dataQuote
      const selected = data.find((val) => val.shipping_type === shipmentMethodName)
      return Boolean(selected)
    }

    const remapAvailableShipment = availableShipmentMethods.map((val) => {
      const isSelected = selectedShipment(val.value)
      if (!val.disabled) {
        return {
          ...val,
          message: isSelected ? 'Selected' : ''
        }
      }
      return {
        ...val
      }
    })
    setAvailableShipmentMethods(remapAvailableShipment)
  }

  useEffect(() => {
    if (dataProductQuote) {
      getPrices(dataProductQuote)
    }
    // eslint-disable-next-line
  }, [dataProductQuote])

  useEffect(() => {
    if (quotePrices) {
      handleUpdateShipmentMethods(quotePrices)
    }
    // eslint-disable-next-line
  }, [quotePrices])

  const handleAddQuotePrices = () => {
    setValidationPrice(priceValidation)
    const dataPrices = quotePrices
    const dataDefault = quotePrices[0]
    const payload = {
      shipping_type: null,
      isUnSavedPrice: true,
      variants: dataDefault.variants
    }
    dataPrices.push(payload)
    setQuotePrices(dataPrices)
    setSelectedIndexPrice(`${Number(selectedIndexPrice) + 1}`)
  }

  const handleDeletePrices = (index) => {
    setValidationPrice(priceValidation)
    const dataPrices = [...quotePrices]
    const dataDeletePrice = quotePrices[index].variants
    const remapIds = dataDeletePrice.map((val) => {
      return val.id
    })
    setDeletePrices((oldVal) => [...oldVal, ...remapIds])

    dataPrices.splice(index, 1)
    setQuotePrices(dataPrices)
    
    setSelectedIndexPrice(`${Number(selectedIndexPrice) > 0 ? Number(selectedIndexPrice) - 1 : Number(selectedIndexPrice)}`)
  }

  const handleChangeFormData = (indexPrice, label, value) => {
    const remap = quotePrices.map((_price, index) => {
      if (index === indexPrice) {
        return {
          ..._price,
          [label]: value,
        }
      }
      else {
        return _price
      }
    })
    setQuotePrices(remap)
  }

  const handleChangePrice = (indexPrice, indexVariant, labelName, value) => {
    const pickDataVariants = quotePrices[indexPrice].variants
    const variants = pickDataVariants.map((_variant, index) => {
      if (indexVariant === index) {
        return {
          ..._variant,
          [labelName]: value
        }
      }
      else {
        return _variant
      }
    })
    handleChangeFormData(indexPrice, 'variants', variants)
  }

  const handleSelectedShipment = (indexPrices, label, valueShipment) => {
    const selectData = availableShipmentMethods.find((val) => val.value === valueShipment)
    if (selectData.message === 'Selected') {
      notificationError('Selected Shipment Not Allowed', 'This shipment has been selected at another price')
    } else {
      handleChangeFormData(indexPrices, label, valueShipment)
    }
  }

  const onCloseModalForm = () => {
    setSelectedIndexPrice(`0`)
    setValidationPrice(priceValidation)
    onCloseModal()
  }

  const renderOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' my={4}>
        <Flex gap='sm' align='center'>
          <Box>
            <Text fz={12} fw='500' lineClamp={2}>{option.label}</Text>
          </Box>
        </Flex>
        {checked ? <IconCheck style={{ marginInlineStart: 'auto' }} /> : option.message ? <Text fz={12} style={{ marginInlineStart: 'auto' }}>{option.message}</Text> : ''}
      </Group>
    )
  }

  const mappingForm = () => {

    const mappingTabPrices = (dataPrices) => {
      const remapTabVariant = dataPrices.map((val, index) => {
        return (<Tabs.Tab key={index} value={`${index}`}>Price {index + 1}</Tabs.Tab>)
      })
      return remapTabVariant
    }
  
    const mappingPanelPrices = (indexPrices) => {

      const mappingTableVariant = (label, dataPrices) => {
        const mappingTableHead = (data) => data.map((val, index) => {
          return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
        })

        const mappingDataTable = (data) => data.map((val, index) => {
          return (
            <Table.Tr key={index}>
              <Table.Td>{val.variantSpesification}</Table.Td>
              <Table.Td>{val.qty}</Table.Td>
              <Table.Td>
                <NumberFormatter prefix={`${val.supplier_currency} `} thousandSeparator="," decimalSeparator="." value={val.supplier_price} />
              </Table.Td>
              <Table.Td>
                <NumberInput
                  value={dataPrices[Number(selectedIndexPrice)].variants[index].landed_cost}
                  leftSection={<Text fz={11} c='black' tt='capitalize'>{dataPrices[Number(selectedIndexPrice)].variants[index].landed_cost_currency}</Text>}
                  onChange={(val) => handleChangePrice(Number(selectedIndexPrice), index, `landed_cost`, val)}
                  thousandSeparator=","
                  size='xs'
                  leftSectionWidth={40}
                />
              </Table.Td>
              <Table.Td>
                <NumberInput
                  value={dataPrices[Number(selectedIndexPrice)].variants[index].vat}
                  rightSection={<Text fz={11} c='black' tt='capitalize'>%</Text>}
                  onChange={(val) => handleChangePrice(Number(selectedIndexPrice), index, `vat`, val)}
                  size='xs'
                  rightSectionWidth={40}
                />
              </Table.Td>
            </Table.Tr>
          )
        })


        return (
          <Table.ScrollContainer type='native'>
            <Table verticalSpacing="xs" highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
              <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                <Table.Tr>
                  {mappingTableHead(label)}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody style={{ verticalAlign: 'center' }}>
                {mappingDataTable(quotePrices[Number(selectedIndexPrice)].variants)}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
        )
      }


      return (
        <Tabs.Panel value={`${indexPrices}`}>
          <Box>
            <Box mb='md'>
              <Select
                name='shipping_type'
                value={quotePrices[Number(indexPrices)].shipping_type}
                label='Shipment Methods'
                placeholder='Set shipment methods'
                data={availableShipmentMethods}
                renderOption={renderOption}
                onOptionSubmit={(val) => handleSelectedShipment(Number(indexPrices), 'shipping_type', val)}
                error={validationPrice.shipping_type.isError ? `${validationPrice.shipping_type.message}` : ''}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Box>
            <ScrollArea h={300} type="auto" offsetScrollbars overscrollBehavior="none" scrollbarSize={4} scrollbars="y">
              {mappingTableVariant(labelTable, quotePrices)}
            </ScrollArea>
            <Flex justify='flex-start' mt={8}>
              <Button size='xs' variant='transparent' leftSection={<IconTrash size={12} />} onClick={() => handleDeletePrices(indexPrices)} disabled={indexPrices < 1}>Remove This Price</Button>
            </Flex>
          </Box>
          
        </Tabs.Panel>
      )
    }
    return (
      <Box>
        <Box my={10}>
          <Flex justify='flex-end' mb='md'>
            <Button size='xs' leftSection={<IconPlus size={12} />} onClick={() => handleAddQuotePrices()}  disabled={quotePrices.length > 2}>Add New Price</Button>
          </Flex>
          <Box my={30}>
            <Tabs variant="pills" size='xs' my={4} value={selectedIndexPrice} onChange={setSelectedIndexPrice}>
              <ScrollArea type="auto" offsetScrollbars overscrollBehavior="none" scrollbarSize={5} scrollbars="x">
                <Tabs.List style={{ width: 'max-content', overflowX: 'hidden'}}>
                  {mappingTabPrices(quotePrices)}
                </Tabs.List>
              </ScrollArea>
              <Divider size='sm' my='xs' />
              {mappingPanelPrices(selectedIndexPrice)}
            </Tabs>
          </Box>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={() => onCloseModal()}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitQuotePrices()}>Submit</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {loadingData ? <LoadingData /> : mappingForm()}
    </Box>
  )
}

export default FormQuoteSetPrices